import { useSetAtom } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";

import useWorkspace from "./useWorkspace";
import useWorkspaces from "./useWorkspaces";
import _ from "underscore";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import useWorkspacePermissions from "../../../hooks/useWorkspacePermissions";
import { newToastEvent } from "../../../utils/ToastUtil";
import WorkspaceAPI from "../../api/WorkspaceAPI";
import { AppConfirm } from "../../../utils/PopupUtil";

const useDeleteWorkspace = () => {
  const navigate = useNavigate();
  const { workspace } = useWorkspace();
  const { workspaces } = useWorkspaces();
  const setWorkspaceID = useSetAtom(workspaceIdAtom);
  const queryClient = useQueryClient();
  const { tenantID }: any = useParams();
  const { wPermissions } = useWorkspacePermissions();

  const deleteWorkspace = useMutation({
    mutationFn: () => {
      if (!wPermissions.workspace_delete_workspace) {
        return Promise.reject(
          "User does not have permission to delete this workspace"
        );
      }

      return AppConfirm({
        title: "Confirm Workspace Deletion",
        html: "Are you sure you want to delete this Workspace? <br/> All the pages inside the workspace will be deleted as well.",
      }).then((result) => {
        if (!result.isConfirmed) return;

        return WorkspaceAPI.deleteWorkspace(workspace?.id).then(() => {
          queryClient.removeQueries({
            queryKey: ["workspace", workspace?.id],
          });
          queryClient.invalidateQueries({
            queryKey: ["workspaces", tenantID],
          });

          newToastEvent(
            "success",
            `Successfully deleted ${workspace?.Name} workspace.`
          );

          let remaining = _.filter(workspaces, (w) => {
            return w.id !== workspace?.id;
          });

          if (remaining?.length) {
            let newWorkspaceID = remaining?.[0]?.id ?? null;

            setWorkspaceID(newWorkspaceID);
            localStorage.setItem("workspaceID", newWorkspaceID);
          } else {
            setWorkspaceID(null);
            localStorage.removeItem("workspaceID");
          }

          navigate(`/clouds/${tenantID}/workspaces`);
        });
      });
    },
  });

  return {
    deleteWorkspace: deleteWorkspace.mutate,
    deleteSubmitting: deleteWorkspace.isPending,
  };
};

export default useDeleteWorkspace;
